module.exports = "/static/img/group.png?5cbd7102aa1e5a41bff8d745d88aaf26";